import { map, Observable, switchMap } from "rxjs";
import { ActivatedRouteSnapshot, RedirectCommand, Router, RouterStateSnapshot } from "@angular/router";
import { inject } from "@angular/core";
import { AccountSelectionService, SpStrategyService } from "@front/m19-services";

export const strategyGroupExistsGuard: (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => Observable<boolean | RedirectCommand> = (route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) => {
  const router = inject(Router);
  const accountSelectionService = inject(AccountSelectionService);
  const spStrategyService = inject(SpStrategyService);

  const groupId = Number(route.paramMap.get("id"));

  return accountSelectionService.singleAccountMarketplaceSelection$.pipe(
    switchMap((am) => spStrategyService.getStrategyGroups(am.accountId, am.marketplace)),
    map((strategyGroups) =>
      strategyGroups.has(groupId)
        ? true
        : new RedirectCommand(
            router.createUrlTree(["/advertising/sponsored-product"], { queryParams: route.queryParams }),
          ),
    ),
  );
};
